module.exports = __webpack_public_path__ + "img/laravel.def095e2.png";